export default {
    data() {
        return {
            nIntervalId: null,
            current: 0,
        };
    },

    computed: {
        currentHumanTime() {
            return this.$moment.unix(this.current).format('YYYY-MM-DD HH:mm:ss');
        },
    },

    mounted() {
        this.createInterval();
    },

    beforeDestroy() {
        this.stopInterval();
    },

    methods: {
        createInterval() {
            this.current = this.$moment().unix();

            this.nIntervalId = setInterval(() => {
                const delayTime = 1; // second 단위
                this.current += delayTime;
            }, 1000);
        },
        stopInterval() {
            if (this.nIntervalId) {
                clearInterval(this.nIntervalId);
                this.nIntervalId = null;
            }
        },
    },

};
